//redux
import { Dispatch } from 'redux';
import { createAction } from 'redux-actions';

//types
import { EmptyCar } from 'app/models';

//actions
export namespace EmptyCarActions {
	export const NEW_TRANSPORT_ID = 'NEW_TRANSPORT_ID';

	export enum Action {
		ADD_EMPTY_CAR = 'ADD_EMPTY_CAR',
		CREATE_NEW_CAR = 'CREATE_NEW_CAR',
		DELETE_EMPTY_CAR = 'DELETE_EMPTY_CAR',
		SET_LOADING_STATE = 'SET_LOADING_STATE',
		SET_OPENED_STATE = 'SET_OPENED_STATE',

		UPDATE_BASE_DATA = 'UPDATE_BASE_DATA',
		UPDATE_TRANSPORT_DATA = 'UPDATE_TRANSPORT_DATA',
		UPDATE_TRAILER_DATA = 'UPDATE_TRAILER_DATA',
		UPDATE_INSURANCE_DATA = 'UPDATE_INSURANCE_DATA',
		UPDATE_DIMENSIONS_DATA = 'UPDATE_DIMENSIONS_DATA',
	}

	export namespace Payload {
		export type CreateNewCarSagaAction = {
			type: string;
			payload: EmptyCar.Data;
		};
	}

	/*
	/ [inner] actions with _ is inner only actions
	/ [outer] actions without _ can be used from other reducers action
	*/

	export const _addCarData = createAction<EmptyCar.Data>(Action.ADD_EMPTY_CAR);
	export const _setOpenedState = createAction<boolean>(Action.SET_OPENED_STATE);

	export const updateBaseData = createAction<Partial<EmptyCar.Base>>(Action.UPDATE_BASE_DATA);
	export const updateTransportData = createAction<Partial<EmptyCar.Certificate>>(Action.UPDATE_TRANSPORT_DATA);
	export const updateTrailerData = createAction<Partial<EmptyCar.Certificate>>(Action.UPDATE_TRAILER_DATA);
	export const updateInsuranceData = createAction<Partial<EmptyCar.Insurance>>(Action.UPDATE_INSURANCE_DATA);
	export const updateDimensionsData = createAction<EmptyCar.Dimensions>(Action.UPDATE_DIMENSIONS_DATA);

	export const setLoadingState = createAction<boolean>(Action.SET_LOADING_STATE);
	export const deleteCarData = createAction(Action.DELETE_EMPTY_CAR);
	export const createNewCar = createAction<EmptyCar.Data>(Action.CREATE_NEW_CAR); //saga action

	export const openEmptyCar = () => (dispatch: Dispatch) => {
		dispatch(_setOpenedState(true));
	};

	export const closeEmptyCar = () => (dispatch: Dispatch) => {
		dispatch(_setOpenedState(false));
	};

	export const addEmptyCar = () => (dispatch: Dispatch) => {
		const data: EmptyCar.Data = {
			base: { ident: '' },
			documents: {},
			dimensions: {},
		};

		dispatch(_addCarData(data));
		dispatch(_setOpenedState(true));
	};
}
